<template>
    <div>
        <h3 class="mb-3" :class="!this.channels.length? 'text-center': ''">Total number of Messages per channel</h3>
<!--        <div class="no-data-placeholder text-center" v-if="!this.channels.length">-->
<!--            <img class="w-h-35 d-block mx-auto my-3" src="../../assets/img/box.svg">-->
<!--            <span class="italic d-block">-->
<!--                No available results for this time period-->
<!--            </span>-->
<!--        </div>-->
        <div class="no-data-placeholder text-center" v-if="!this.channels.length">
            <v-progress-circular
                    :rotate="-90"
                    :size="220"
                    :value="100 "
                    :width="30"
                    color="grey"
            >
                <span>Total Messages</span>
                <span>0</span>
            </v-progress-circular>
        </div>

        <apex-chart type="donut" :options="chartOptions" :series="series"></apex-chart>

    </div>
</template>

<script>
    import apexChart from 'vue-apexcharts'
    export default {
        name: "total-messages",
        components: {
            apexChart
        },
        props: {
            channels: {
                type: Array,
                default: ()=> {
                    return []
                }
            }
        },
        data() {
            return {
                series: [],
                chartOptions: {
                    plotOptions: {
                        pie: {
                            donut: {
                                labels: {
                                    show: true,
                                    value: {
                                        offsetY: -1,
                                        show: true,
                                        // formatter: function (val) {
                                        //     console.log(val, ' formatter')
                                        //     return val.toFixed(2)
                                        // }
                                    },
                                    total: {
                                        show: true,
                                        label: 'Total Messages',
                                        color: '#000',


                                    }
                                },
                            }
                        }
                    },
                    labels: [],
                    chart: {
                        type: 'donut'
                    }
                }
            }
        },
        mounted() {
        },
        watch: {
            channels() {
                this.series = []
                this.chartOptions.labels = []
                let labels = []
                for (let i=0;i<this.channels.length;i++) {
                    this.series.push(this.channels[i].data.total_messages);
                    labels.push(this.channels[i].name)
                }
                this.chartOptions= {
                    labels: labels
                }
            }
        }
    }
</script>

<style scoped>
.no-data-placeholder{
    margin-top: 30px;
}
</style>
